import React from "react";
import { DateToString } from "components/Reports/DateFilter";
import { useFormikContext } from "formik";
import useCurrency from "helpers/useCurrency";
// @ts-ignore
import Num2persian from "num2persian";
import BasicButton from "components/BasicInputs/BasicButton";
import RefreshIcon from "assets/icons/RefreshIcon";
const moment = require("moment-jalaali");

type Props = {};

function CalculateInstalment({}: Props) {
  const data = useFormikContext<InstallmentData>();

  function calculateInstallments() {
    const v = data.values;
    const { installmentsCount, installmentsGap, totalPrice } = v;
    if (!installmentsCount || !installmentsGap || !totalPrice) return;

    const prePay = v.prePayType === "currency" ? v.prePay || 0 : totalPrice * ((v.prePay || 0) / 100);
    const profit = v.totalProfit || 0;

    let price = Math.floor((profit + totalPrice - prePay) / installmentsCount);
    const lastInstallmentPrice = profit + totalPrice - prePay - price * (installmentsCount - 1);

    const penalty =
      v.penaltyRateType === "currency" ? v.penaltyRate || 0 : price * ((v.penaltyRate || 0) / 100);

    const d = data.values.installmentsFirstRepayDate || DateToString(new Date(Date.now()));
    let gap = 0;

    const installments = Array.from(Array(installmentsCount).keys()).map((index) => {
      const g = gap;
      const type = data.values.installmentsGapType || "month";
      const types = { day: "day", month: "jMonth", year: "jYear" };
      const m = moment(d, "jYYYY/jM/jD");
      const date = m.add(g, types[type]).format("jYYYY/jM/jD");
      gap = (data.values.installmentsGap || 0) + gap;
      const s = ["اول", "دوم", "سوم"];
      let suffix = s[index] || Num2persian(index + 1) + "م";

      const installmentPrice = index === installmentsCount - 1 ? lastInstallmentPrice : price;

      return {
        id: index,
        title: `قسط ${suffix}`,
        price: installmentPrice,
        date,
      };
    });

    data.setFieldValue("installmentRows", installments);
  }
  return (
    <div className="pb-6">
      <div
        className="flex items-center justify-end p-4 "
        // onClick={() => setAppear((x) => !x)}
      >
        <BasicButton variant="outlined" onClick={calculateInstallments} className="bg-white">
          <RefreshIcon scale={0.8} />
          <span>محاسبه کن</span>
        </BasicButton>
      </div>
    </div>
  );
}

export default CalculateInstalment;
